import { getCookie, isCookieValid, setCookie } from "../../utils/cookies";

export class AuthCookies {
  static readonly COOKIE_NAME_TOKEN = "tm_token";
  static readonly COOKIE_NAME_UUID = "tm_uuid";
  static readonly COOKIE_NAME_PREMIUM = "tm_p";
  static readonly COOKIE_NAME_GOOGLE_POPUP = "g_skip_prompt_cookie";

  static readonly DAYS_TO_EXPIRE = 60;

  static login(token: string, uuid: string, isPremium?: boolean) {
    setCookie(this.COOKIE_NAME_TOKEN, token, this.DAYS_TO_EXPIRE);
    setCookie(this.COOKIE_NAME_UUID, uuid, this.DAYS_TO_EXPIRE);
    setCookie(this.COOKIE_NAME_GOOGLE_POPUP, 'true', this.DAYS_TO_EXPIRE);
    if (isPremium) {
      setCookie(this.COOKIE_NAME_PREMIUM, 'true', this.DAYS_TO_EXPIRE);
    } else {
      setCookie(this.COOKIE_NAME_PREMIUM);
    }
  }

  static logout() {
    setCookie(this.COOKIE_NAME_TOKEN);
    setCookie(this.COOKIE_NAME_UUID);
    setCookie(this.COOKIE_NAME_GOOGLE_POPUP);
    setCookie(this.COOKIE_NAME_PREMIUM);
  }

  static validate(shouldExist: boolean): boolean {
    const cookiesExist = isCookieValid(this.COOKIE_NAME_TOKEN) && isCookieValid(this.COOKIE_NAME_UUID);
    return shouldExist ? cookiesExist : !cookiesExist;
  }

  static getToken(): string {
    return getCookie(this.COOKIE_NAME_TOKEN);
  }

  static getUUID(): string {
    return getCookie(this.COOKIE_NAME_UUID);
  }
}